export default "__VITE_ASSET__c_kFR6lE__"